/**
 * The closing note this page suggests when a report is marked Fixed.
 */
import type { FeedbackReport } from '../../services/feedbackTriageApi';

/**
 * The same shape the proxy builds, and deliberately not model-written: the substance is the
 * decision line the person already typed, and a model asked to pad one sentence into a paragraph
 * costs a call and a review step to add words nobody needs.
 *
 * ⚠️ `buildResolutionDraft` in `proxy-server/lib/feedbackReply.js` is the other copy. It exists
 * so the shape is pinned on the side that actually posts; if you change the wording, change both.
 */
export function buildResolutionDraft(report: FeedbackReport): string {
  const lines = ['✅ This one is fixed.'];
  if (report.decision.trim()) lines.push('', report.decision.trim());
  if (report.fixUrl.trim()) lines.push('', `Fix: ${report.fixUrl.trim()}`);
  lines.push('', 'Thanks for reporting it.');
  return lines.join('\n');
}
